import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE = defineFcm('psf_share_initial_above_button_message')
	.asString()
	.withDefault(undefined)
	.toConfig();
